<script lang="ts">
  import { t } from '@dabble/data/intl';
  import ToolButton from '@dabble/toolkit/ToolButton.svelte';
  import { mdiCardMultiple } from '@mdi/js';
</script>

<ToolButton sidebar="novel_notes" icon={mdiCardMultiple} tooltip={$t('novel_doc_descriptions')} />
